import React from 'react';
import PropTypes from 'prop-types';
import LotSearchControls, {VIEW_TYPE_GRID} from "./LotSearchControls";
import LotSearchContent from "./LotSearchContent";
import ListingHeader from "../../listing/js/ListingHeader";
import ListingContentWrapper from "../../listing/js/ListingContentWrapper";
import LotSearchInfo from "./LotSearchInfo";
import Listing from "../../listing/js/Listing";
import {getDefaultFilters} from "../../listing/js/listing-helper";
import ListingControlsWrapper from "../../listing/js/ListingControlsWrapper";

const VIEW_TYPE_STORAGE_KEY = 'lostSearchViewType';

const isGridView = function (viewType) {
    return viewType === VIEW_TYPE_GRID;
};

export default class LotsSearch extends React.PureComponent {

    constructor(props) {
        super(props);

        let viewType = localStorage.getItem(VIEW_TYPE_STORAGE_KEY) || VIEW_TYPE_GRID;
        this.state = {
            viewType: viewType,
            isGridView: isGridView(viewType)
        };

        this.onViewTypeChange = this.onViewTypeChange.bind(this);

        this.defaultFilters = {
            content: '',
            type: '',
            ...getDefaultFilters(props.options.filters)
        };
    }

    onViewTypeChange(currentViewType, animateChange) {
        localStorage.setItem(VIEW_TYPE_STORAGE_KEY, currentViewType);
        animateChange(() => {
            this.setState({
                viewType: currentViewType,
                isGridView: isGridView(currentViewType)
            });
        });
    }

    onQueryTypeClear(onFiltersChange) {
        onFiltersChange({type: ''});
    }

    onPredictiveSearchChange(search, onFiltersChange) {
        onFiltersChange({
            content: search.query,
            type: search.queryType,
        });
    }

    render() {
        return (
            <Listing options={this.props.options} defaultFilters={this.defaultFilters}
                     render={({
                                  isInitialRequestFulfilled,
                                  onFiltersChange,
                                  controls,
                                  filters,
                                  items,
                                  pagination,
                                  animateChange
                              }) => (
                         <div>
                             <ListingHeader>
                                 {this.props.options.title ? <div className="lots-search__title"
                                                                  dangerouslySetInnerHTML={{__html: this.props.options.title}}/> : null}
                                 <ListingControlsWrapper controls={controls}>
                                     <LotSearchControls options={this.props.options}
                                                        filters={filters}
                                                        onFiltersChange={onFiltersChange}
                                                        onPredictiveSearchChange={(search) => this.onPredictiveSearchChange(search, onFiltersChange)}
                                                        onViewTypeChange={(currentViewType) => this.onViewTypeChange(currentViewType, animateChange)}
                                                        viewType={this.state.viewType}/>
                                 </ListingControlsWrapper>
                             </ListingHeader>
                             <div className="listing__content">
                                 <div className="container">
                                     <LotSearchInfo items={items}
                                                    pagination={pagination}
                                                    query={filters.content}
                                                    queryType={filters.type}
                                                    onQueryTypeClear={() => this.onQueryTypeClear(onFiltersChange)}/>
                                     <ListingContentWrapper isInitialRequestFulfilled={isInitialRequestFulfilled}
                                                                    itemsCount={items.length}
                                                                    emptyResult={this.props.options.emptyResult}>
                                         <LotSearchContent items={items}
                                                           isGridView={this.state.isGridView}/>
                                     </ListingContentWrapper>
                                 </div>
                             </div>
                         </div>
                     )}/>
        );
    }
}

LotsSearch.propTypes = {
    options: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./app/components/lots-search/js/LotsSearch.js